import React from 'react';
import FlagIcon from './FlagIcon';

export default function ThirdPlacePicker({ groups, picks, teamsByGroup, selected, onToggle, locked }) {
  return (
    <div className="third-place-section">
      <h2>Which 3rd-Place Teams Advance?</h2>
      <p className="info">
        The 8 best 3rd-place teams (out of 12) advance to the Round of 32.
        Pick which 8 groups' 3rd-place finishers you think will make it through.
        Based on your group stage picks, the predicted 3rd-place team from each group is shown below.
      </p>
      <div className={`third-count ${selected.length === 8 ? 'full' : ''}`}>
        Selected: {selected.length}/8 {selected.length === 8 ? '✓ Done!' : `— pick ${8 - selected.length} more`}
      </div>
      <div className="third-place-grid mt-2">
        {groups.map(g => {
          const gTeams = teamsByGroup(g);
          const groupOrder = picks.groups?.[g] || gTeams.map(t => t.id);
          const thirdTeamId = groupOrder[2];
          const thirdTeam = gTeams.find(t => t.id === thirdTeamId);
          const isSelected = selected.includes(g);
          const isDisabled = locked || (!isSelected && selected.length >= 8);

          return (
            <div
              key={g}
              className={`third-place-item ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
              onClick={() => !locked && !isDisabled && onToggle(g)}
            >
              {isSelected ? '✓' : '○'}
              {thirdTeam && <FlagIcon code={thirdTeam.country_code} size="1.1em" />}
              <div>
                <div style={{ fontWeight: 600, fontSize: '0.8rem' }}>Group {g} 3rd</div>
                <div style={{ fontSize: '0.75rem', opacity: 0.8 }}>{thirdTeam?.name || '—'}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
